'use client'

import { Button, styled } from '@mui/material'
import { memo } from 'react'
import { ExplorerSection } from 'types/explorer'

type NavButtonProps = {
  text: string
  onClick: (value: ExplorerSection) => void
  isActive?: boolean
  icon?: React.ReactNode
}

/**
 * One section of the explorer, as a pill.
 *
 * The selected section is the primary pill (white fill, black label) and the
 * rest are the secondary one. Nothing is outlined; which pill is filled white
 * is the only thing that says where you are.
 */
const NavItem = styled(Button)(({ is_active }: { is_active: string }) => {
  const active = is_active === 'true'
  return {
    textTransform: 'capitalize',
    borderRadius: 'var(--dewi_radius_rounded)',
    border: 'none !important',
    borderWidth: 0,
    boxShadow: 'none',
    background: active
      ? 'var(--dewi_colors_gray_0) !important'
      : 'var(--dewi_pill_secondary) !important',
    backgroundColor: active
      ? 'var(--dewi_colors_gray_0) !important'
      : 'var(--dewi_pill_secondary) !important',
    color: active
      ? 'var(--dewi_colors_dark_9) !important'
      : 'var(--dewi_colors_gray_0) !important',
    '&:hover': {
      border: 'none !important',
      background: active
        ? 'var(--dewi_colors_gray_2) !important'
        : 'var(--dewi_pill_secondary_hover) !important',
      backgroundColor: active
        ? 'var(--dewi_colors_gray_2) !important'
        : 'var(--dewi_pill_secondary_hover) !important',
    },
    '&.Mui-disabled': {
      border: 'none !important',
    },
  }
})

const NavigationButton = ({
  text,
  onClick,
  isActive = false,
  icon,
}: NavButtonProps) => {
  return (
    <NavItem
      is_active={isActive.toString()}
      onClick={() => onClick(text as ExplorerSection)}
      value={text}
    >
      {!icon && (
        <p className="font-sans font-bold text-xs xs:text-sm">{text}</p>
      )}
      {icon && icon}
    </NavItem>
  )
}

export default memo(NavigationButton)
